module.exports = __webpack_public_path__ + "media/images/category/feature/coj_e/coj_e-5-24bfba629710ae528975037152787271.jpg";